/* eslint-disable react/display-name */
/* eslint-disable react/jsx-closing-tag-location */
import React, { useState, useEffect } from 'react'
import { Choose } from 'react-extras'

import { Button, Card, Typography, Form, Icon, Row, Col, Tabs, DatePicker, Modal, Spin } from 'antd'
import ptBR from 'antd/es/locale/pt_BR'
import { Formik } from 'formik'
import moment from 'moment'

import { CustomBreadcrumb } from '../../../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomSelect from '../../../../components/CustomSelect/customSelect'
import { TableLineDisable } from '../../../../components/TableLineDisable/TableLineDisable'
import { validRule, RULES } from '../../../../constants/Entitlements'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'
import ActionsCalendar from './ActionsCalendar'

import './actionStyles.css'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const { TabPane } = Tabs

const TIME_FORMATS = {
  dmyhmFull: 'DD-MM-YYYY HH:mm',
  dmyhmFullSlash: 'DD/MM/YYYY HH:mm'
}

const ShowCalendar = function ({ match, history }) {
  const [uiDisplay, setUiDisplay] = useState({ form_modal: false })
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({
    date: moment()
  })
  const [modalForm, setModalForm] = useState({})
  const [modalFormData, setModalFormData] = useState({})

  // Created component
  useEffect(() => {
    const hasAccess = validRule(RULES.ACTION) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
    listActions(formValues)
    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  const mergeCallParams = () => listActions({ ...formValues, ...modalForm })

  function formatHour(data) {
    if (data) {
      return moment(data).format(TIME_FORMATS.dmyhmFullSlash)
    }

    return '-'
  }

  // Api requests
  async function listActions(params) {
    try {
      console.tron.log(params)
      delete params.date
      const items = await request(api.listActions(params))

      const formatedRows = items.map((item) => ({
        title: item.actionSubject,
        start: formatHour(item.actionPlannedDoneTime),
        end: formatHour(item.actionPlannedDoneTime),
        id: item.id,
        typeId: item.actionTypeId,
        status: formatStatus(item.actionStatus),
        actions: formatActions(item.id)
      }))

      const data = { ...[], items: formatedRows }

      setFormatedData(data)
    } catch (error) {
      console.tron.log(error)
    }
  }

  const formatActions = (id) => PAGE_COMPONENTS.ActionsRowComp(id)

  const formatStatus = (status) => {
    let className
    let content

    switch (status) {
      case 'NAO_PLANEJADA':
        className = 'ghost'
        content = getMessage('actions.list.status.pending')
        break
      case 'CANCELADA':
        className = 'warning'
        content = getMessage('actions.list.status.cancelled')
        break
      case 'PLANEJADA':
        className = 'success'
        content = getMessage('actions.list.status.planned')
        break
      case 'REALIZADA':
        className = 'success'
        content = getMessage('actions.list.status.finished')
        break
      case 'ATRASADA':
        className = 'info'
        content = getMessage('actions.list.status.late')
        break
      default:
        className = 'ghost'
        content = getMessage('actions.list.status.pending')
    }
    const compData = { className, content }
    return PAGE_COMPONENTS.StatusBadgeComp(compData)
  }

  const setFieldValueWithState = (field, key) => {
    setModalForm({ ...modalForm, [field]: key })
  }

  const loadModalFormData = async () => {
    const actionTypeData = await request(api.listActionTypes()).then((data) =>
      data.data.items.map((v) => ({ value: v.id, description: v.typeName }))
    )

    const cityData = await request(api.listCities()).then((data) =>
      data.items.map((v) => ({ value: v.id, description: v.cityName }))
    )

    const businessAreaData = await request(api.listBusinessAreas()).then((data) =>
      data.items.map((v) => ({ value: v.id, description: v.organizationName }))
    )

    const federalStateData = await request(api.listStates()).then((data) =>
      data.items.map((v) => ({ value: v.stateAbbreviation, description: v.stateName }))
    )

    const districtDate = await request(api.listDistrict()).then((data) =>
      data.items.map((v) => ({ value: v.id, description: v.districtName }))
    )

    const regionalDate = await request(api.listRegion()).then((data) =>
      data.items.map((v) => ({ value: v.id, description: v.name }))
    )

    setModalFormData({
      actionTypeData,
      businessAreaData,
      federalStateData,
      cityData,
      districtDate,
      regionalDate
    })
  }

  const hasState = (state) => Object.keys(state).length > 0

  const toggleUI = (key) => {
    if (!hasState(modalFormData)) loadModalFormData()
    return setUiDisplay({ [key]: !uiDisplay[key] })
  }

  const setFormDataKey = (key, value) => setFormValues({ ...formValues, [key]: value })

  const COMPONENTS = () => {
    // COMPONENT IS BROKEN
    // eslint-disable-next-line no-unused-vars
    const DateRangePicker = ({ value, onOk, defltTime = moment() }) => {
      let _time = moment()
      const handleOk = (date) => setFormDataKey(date, _time)
      return (
        <div style={{ marginTop: 5 }}>
          <DatePicker
            onOk={handleOk}
            defaultValue={defltTime}
            showTime={{ format: 'HH:mm' }}
            format={TIME_FORMATS.dmyhmFull}
            bordered={false}
            locale={ptBR}
            onChange={(date) => (_time = date)}
          />
        </div>
      )
    }

    const TableLineDisableComp = (item, line) => <TableLineDisable item={item} line={line} />

    const _RowInteractionComp = (route, id) => (
      <Button
        style={{ display: 'block', margin: 0 }}
        type="link"
        onClick={() => {
          history.push(`/actions/${id}`)
        }}
      >
        <Icon type="edit" style={{ fontSize: 24 }} />
      </Button>
    )

    const ActionsRowComp = (id) => {
      return _RowInteractionComp('actions', id)
    }

    const StatusBadgeComp = ({ className, content }) => {
      return <div className={`mxi-status-badge ${className}`}>{content}</div>
    }

    return {
      DateRangePicker,
      TableLineDisableComp,
      ActionsRowComp,
      StatusBadgeComp
    }
  }

  const STYLES = () => {
    const CONSTANTS = {
      fullWidthBtn: 150
    }
    const alignCenter = { display: 'block', marginLeft: 'auto', marginRight: 'auto' }
    const InputSearchStyle = { margin: '5px 0px' }
    const ContentCol = { marginTop: 10 }
    const ResetMargin = { margin: '0 0 0 0' }
    const PageBottomMargin = { paddingBottom: '0.5rem' }
    const flexBarFullWidth = {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
    const alignButtonToInput = { marginTop: 20 }
    const modalMainButton = {
      width: CONSTANTS.fullWidthBtn,
      marginRight: CONSTANTS.fullWidthBtn + 10
    }

    return {
      alignCenter,
      InputSearchStyle,
      ContentCol,
      ResetMargin,
      PageBottomMargin,
      flexBarFullWidth,
      alignButtonToInput,
      modalMainButton
    }
  }

  const PAGE_COMPONENTS = COMPONENTS()
  const PAGE_STYLES = STYLES()

  const RenderFilterModal = ({ toggleClose, onOk, text, content }) => {
    const [isVisible, setVisible] = useState(uiDisplay.form_modal)
    const { title } = text

    const handleClose = () => setVisible(false)

    const handleOk = () => {
      setTimeout(onOk, 50)
      return handleClose()
    }

    return (
      <Modal
        centered
        closable={false}
        title={title}
        visible={isVisible}
        onOk={handleOk}
        onCancel={handleClose}
        afterClose={toggleClose}
        zIndex={10}
        footer={[
          <Button
            className="bgPrimary"
            key={'filter_btn'}
            type="primary"
            style={PAGE_STYLES.modalMainButton}
            onClick={handleOk}
          >
            {getMessage('actions.list.buttons.filter')}
          </Button>
        ]}
      >
        {content}
      </Modal>
    )
  }

  const hasAccess = validRule(RULES.ACTION)

  const renderHeader = () => (
    <div style={PAGE_STYLES.PageBottomMargin}>
      <div style={PAGE_STYLES.flexBarFullWidth}>
        <CustomBreadcrumb match={match} history={history} />
        {hasAccess && (
          <Button className="bgPrimary button-action" type="primary" onClick={() => history.push('/actions/create')}>
            {getMessage('createAction')}
          </Button>
        )}
      </div>
    </div>
  )

  const renderTabs = () => (
    <Card className="ant-card gx-card ant-card-bordered">
      <Typography.Title className="default-header-title" level={3}>
        {' '}
        {getMessage('sidebar.actions.title')}{' '}
      </Typography.Title>
      <Row type="flex" justify="start">
        <Col span={24}>
          <Tabs type="card">
            {/* <TabPane tab={getMessage('actions.tabs.list')} key="3">
              <div className="top-margin-filters">{renderListForm()}</div>
            </TabPane> */}
            <TabPane tab={getMessage('actions.tabs.calendar')} key="1">
              <Choose>
                <Choose.When
                  condition={formatedData !== null && Array.isArray(formatedData.items) && listActions !== null}
                >
                  <ActionsCalendar data={formatedData} onLoad={listActions} history={history} />
                </Choose.When>
              </Choose>
            </TabPane>
            {/* <TabPane tab={getMessage('actions.tabs.timeline')} key="1">
              <ActionsTimeline data={formatedData} onLoad={listActions} />
            </TabPane> */}
          </Tabs>
        </Col>
      </Row>
    </Card>
  )

  const renderModals = () => (
    <RenderFilterModal
      text={{ title: getMessage('actions.list.buttons.filterBy') }}
      toggleClose={() => toggleUI('form_modal')}
      onOk={mergeCallParams}
      content={RenderModalForm()}
    />
  )

  const ModalFormSelect = ({ values, modalKey, field, fn }) => (
    <>
      {modalFormData[modalKey] && (
        <CustomSelect
          showSearch
          disabled={false}
          setFieldValue={setFieldValueWithState}
          field={field}
          errors={fn.errors}
          rowSpan={24}
          value={values}
          values={modalFormData[modalKey]}
          handleBlur={fn.handleBlur}
        />
      )}
    </>
  )

  const RenderModalForm = () => (
    <Formik initialValues={modalForm} validateOnChange={false} validateOnBlur={false}>
      {({ values, errors, handleBlur }) => {
        const fn = { errors, handleBlur }
        return (
          <Form className="login-form form-customer" layout="vertical">
            {(!hasState(modalFormData) && <Spin style={PAGE_STYLES.alignCenter} />) || (
              <>
                {ModalFormSelect({ values, fn, modalKey: 'actionTypeData', field: 'actionTypeId' })}
                {/* {ModalFormSelect({ values, fn, modalKey: 'businessAreaData', field: 'listBusinessAreas' })} */}
                {ModalFormSelect({ values, fn, modalKey: 'federalStateData', field: 'stateAbbreviation' })}
                {ModalFormSelect({ values, fn, modalKey: 'cityData', field: 'cityName' })}
                {ModalFormSelect({ values, fn, modalKey: 'districtDate', field: 'districtId' })}
                {ModalFormSelect({ values, fn, modalKey: 'regionalDate', field: 'regionId' })}
              </>
            )}
          </Form>
        )
      }}
    </Formik>
  )

  return (
    <>
      {renderHeader()}
      {renderTabs()}
      {renderModals()}
    </>
  )
}

export default ShowCalendar
